/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PriceListDatesRequest;
(function (PriceListDatesRequest) {
    var gsaFilter;
    (function (gsaFilter) {
        gsaFilter["GSA_ONLY"] = "GSA Only";
        gsaFilter["COMMERCIAL_ONLY"] = "Commercial Only";
    })(gsaFilter = PriceListDatesRequest.gsaFilter || (PriceListDatesRequest.gsaFilter = {}));
    var newFilter;
    (function (newFilter) {
        newFilter["NEW_ONLY"] = "New Only";
        newFilter["NOT_NEW"] = "Not New";
    })(newFilter = PriceListDatesRequest.newFilter || (PriceListDatesRequest.newFilter = {}));
})(PriceListDatesRequest || (PriceListDatesRequest = {}));
